import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { FcmNotification } from './../../../models/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/providers/api.service';
import { InvoiceComponent } from '../invoice/invoice.component';
import { Subscription } from 'rxjs';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { COUNTRY_CODES } from '../../data/country-codes';
@Component({
  selector: 'sm-add-future-bookings',
  templateUrl: './add-future-bookings.component.html',
  styleUrls: ['./add-future-bookings.component.scss']
})
export class AddFutureBookingsComponent implements OnInit, OnDestroy {
  public newbookingData: any = {
    price: 0

  }
  maxDate: Date = new Date()
  tomorrowDate: Date = new Date()

  selectedDate:any
  selectedTime:any
  private _apiSubscription: Subscription = new Subscription();
  selectedBookingType: number = 1
  selectedServiceType: number = 1
  serviceList: any = []
  ogServiceList: any = []
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService, public _modelRef: MatDialog,  private loader: LoaderServiceService,
  ) {}
  ngOnInit(): void {
    this.tomorrowDate.setDate(this.tomorrowDate.getDate() + 1)
    this.maxDate.setDate(this.tomorrowDate.getDate() + 90)

    let data = this.parentData.data


    this._apiService.getServicesTypesList(data.entityHash,'0',this.selectedServiceType.toString())

    this._apiSubscription =  this._apiService.apiResult.subscribe((resData) => {
      console.log("inAddBookings2:", resData)
      if(resData.responseType === SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT){
        console.log(resData);
       
        this.serviceList = [];
        this.ogServiceList = [];
        this.ogServiceList = resData.result
        if (this.selectedServiceType == 1) {
          resData.result.forEach((element: any) => {
            if (element.shopStatus == 1) {
              element.toShow = true 
              this.serviceList.push(element);
            }
          });
          // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
        } else if (this.selectedServiceType == 0) {
          resData.result.forEach((element: any) => {
            if (element.homeStatus == 1){
              element.toShow = true 
              this.serviceList.push(element);
            } 
          });
          // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
        }
        
      
        
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS){
        if (resData.result) {
          this.parentData.ref.closeAll();
        } 
        
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_WITH_INVOICE){
        if (resData.result) {
          this.parentData.ref.closeAll();

          this._modelRef.open(InvoiceComponent, {
            width: '510px',
            data: {
              title: 'Invoice',
              ref: this._modelRef,
              data: JSON.parse(resData.result).bookingHashId
            },
          });
        } 
        
      }
    });
  }

  countryList: {name: string; dial_code: string; code: string; flag: string; preferred?: any;}[] = COUNTRY_CODES;
  selectedCountryCode:any = this.countryList.find(country => country.dial_code === '+91')
  searchString: any = '';
  onCountrySelected(event: any): void {
    console.log(event);
    
    this.selectedCountryCode = this.countryList.find(country => country.dial_code === event.value.dial_code)
    console.log(this.selectedCountryCode);
    
    this.searchString = ''
    this.countryList = COUNTRY_CODES
  }
  onKey() {
    console.log(this.searchString);

    this.countryList= [];
    this.selectSearch(this.searchString);
}

selectSearch(value:string){
  let filter = value.toLowerCase();
  for ( let i = 0 ; i < COUNTRY_CODES.length; i ++ ) {
      let option = COUNTRY_CODES[i];
      if (  option.name.toLowerCase().indexOf(filter) >= 0) {
          this.countryList.push( option );
      }
  }
}

formChecker(){
  if(this.newbookingData.customerPh){
    if(this.newbookingData.customerPh.length == 10){
      return false
    }
    else{
      return true
    }
  }
  else{
    return false
  }
}


  serviceInfo: any = []
  onPost() {
  this.serviceInfo = []

    this.selectedJobs.forEach((element:any) => {
      this.serviceInfo.push({
        serviceTypeHash: element.hash_id,
        serviceName: element.serviceName,
        description: element.description,
        imgUrl: element.imgUrl,
        rate: (this.selectedServiceType == 0) 
        ? (element.discountStatus == 1 ? element.homeDiscountedPrice : element.home_rate)
        : (element.discountStatus == 1 ? element.shopDiscountedPrice : element.shop_rate),
        approxTime: element.approxTime,
        shop_rate:element.shop_rate,
        home_rate: element.home_rate,
        shopStatus: element.shopStatus,
        homeStatus:element.homeStatus,
        discountStatus: element.discountStatus,
        discountType: element.discountType,
        discountAmount: element.discountAmount,
        shopDiscountedPrice: element.shopDiscountedPrice,
        homeDiscountedPrice: element.homeDiscountedPrice

      })

    });
   
    let data = {
      bookingStatusInfo : {
        assignedToHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        bookingType: this.selectedServiceType,
        appointmentHash: "",
        assignedByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        entityHash:  this.parentData.data.entityHash, 
        bookingStatus: this.selectedBookingType,
        price: this.newbookingData.price,
        startTime: this.convertTo24HourFormat(this.selectedTime),
        endTime: this.addOneHour(this.convertTo24HourFormat(this.selectedTime)),
        note: this.newbookingData.note ?? '',
        newCustomer: 1,
        customerName: this.newbookingData.customerName ? this.newbookingData.customerName : 'New Customer',
        customerPh:this.newbookingData.customerPh ? this.selectedCountryCode.dial_code + this.newbookingData.customerPh : this.selectedCountryCode.dial_code +  '0000000000',
        servicesInfo: this.serviceInfo,
        bookingDate: this.formatDate(new Date(this.selectedDate).toLocaleDateString())
      }

      
    }
    Object.keys(data.bookingStatusInfo).forEach(key => {
      if ((data.bookingStatusInfo as any)[key] === null) {
        delete (data.bookingStatusInfo as any)[key];
      }
    });


    console.log(data);

    this.loader.showLoader = true;
    this._apiService.updateBookingStatus(data)
    
    
  }

  addOneHour(timeStr:any) {
    // Split the input time string into hours and minutes
    let [hours, minutes] = timeStr.split(':').map(Number);

    // Add one hour
    hours += 1;

    // Handle the overflow of hours
    if (hours === 24) {
        hours = 0;
    }

    // Format the hours and minutes back to a string with leading zeros if necessary
    let newTimeStr = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

    return newTimeStr;
}


  allDone() {
  this.serviceInfo = []

    this.selectedJobs.forEach((element:any) => {
      this.serviceInfo.push({
        service_hash_id: element.hash_id,
        service_name: element.serviceName,
        description: element.description,
        img_url: element.imgUrl,
        approxTime: element.approxTime,
        completed_by_hash_id: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        service_cost: (this.selectedServiceType == 0) 
                      ? (element.discountStatus == 1 ? element.homeDiscountedPrice : element.home_rate)
                      : (element.discountStatus == 1 ? element.shopDiscountedPrice : element.shop_rate),
        current_status: 3

      })

    });
   
    let data = {
      bookingStatusInfo : {
        assignedToHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        bookingType: this.selectedServiceType,
        appointmentHash: "",
        assignedByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        entityHash:  this.parentData.data.entityHash, 
        bookingStatus: this.selectedBookingType,
        price: this.newbookingData.price.toString(),
        startTime: this.formatTime(new Date()),
        endTime: this.formatTime(new Date()),
        note: this.newbookingData.note ? this.newbookingData.note : "",
        customerPh: this.newbookingData.customerPh ? this.selectedCountryCode.dial_code + this.newbookingData.customerPh : this.selectedCountryCode.dial_code +  '0000000000',
        customerName: this.newbookingData.customerName ? this.newbookingData.customerName : 'New Customer',
        completedServices: this.serviceInfo,
        bookingDate: this.formatDateString(new Date())
      }

      
    }


    console.log(data);
    this.loader.showLoader = true;
    this._apiService.updateBookingStatusWithInvoice(data)
    
    
  }


  completedServices: any = []
  partiallyDone(){

    this.selectedJobs.forEach((element:any) => {
      this.completedServices.push({
        service_hash_id: element.hash_id,
        service_name: element.serviceName,
        description: element.description,
        imgUrl: element.imgUrl,
        approxTime: element.approxTime,
        completed_by_hash_id: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        service_cost: (this.selectedServiceType == 0) 
                      ? (element.discountStatus == 1 ? element.homeDiscountedPrice : element.home_rate)
                      : (element.discountStatus == 1 ? element.shopDiscountedPrice : element.shop_rate),
        current_status: 3
      })

    });


    let data = {
      bookingStatusInfo : {
        appointmentHash: "",
        assignedToHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        bookingType: this.selectedServiceType,
        assignedByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        entityHash:  this.parentData.data.entityHash, 
        bookingStatus: 9,
        price: this.newbookingData.price,
        startTime: this.formatTime(new Date()),
        endTime: this.addOneHourAndFormat(new Date()),
        note: this.newbookingData.note,
        customerPh: this.newbookingData.customerPh ? this.selectedCountryCode.dial_code + this.newbookingData.customerPh : this.selectedCountryCode.dial_code +  '0000000000',
        customerName: this.newbookingData.customerName ? this.newbookingData.customerName : 'New Customer',
        completedServices: this.completedServices,
        bookingDate: this.formatDateString(new Date())
      }

      
    }

    console.log(data);
    this.loader.showLoader = true;
    this._apiService.updateBookingStatus(data)

  }
  allDoneAndRelease(){

    this.selectedJobs.forEach((element:any) => {
      this.completedServices.push({
        service_hash_id: element.hash_id,
        service_name: element.serviceName,
        description: element.description,
        imgUrl: element.imgUrl,
        approxTime: element.approxTime,
        completed_by_hash_id: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        service_cost: (this.selectedServiceType == 0) 
                      ? (element.discountStatus == 1 ? element.homeDiscountedPrice : element.home_rate)
                      : (element.discountStatus == 1 ? element.shopDiscountedPrice : element.shop_rate),
        current_status: 3
      })

    });


    let data = {
      bookingStatusInfo : {
        appointmentHash: "",
        assignedToHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        bookingType: this.selectedServiceType,
        assignedByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        entityHash:  this.parentData.data.entityHash, 
        bookingStatus: 4,
        price: this.newbookingData.price,
        startTime: this.formatTime(new Date()),
        endTime: this.addOneHourAndFormat(new Date()),
        note: this.newbookingData.note,
        customerPh: this.newbookingData.customerPh ? this.selectedCountryCode.dial_code + this.newbookingData.customerPh : this.selectedCountryCode.dial_code +  '0000000000',
        customerName: this.newbookingData.customerName ? this.newbookingData.customerName : 'New Customer',
        completedServices: this.completedServices,
        bookingDate: this.formatDateString(new Date())
      }

      
    }

    console.log(data);
    this.loader.showLoader = true;
    this._apiService.updateBookingStatus(data)

  }


  changeChip(value:number){
    // this.selectedBookingType = value
    this.selectedServiceType = value
    this.selectedJobs = [];
    this.newbookingData.price = 0;
    this.serviceList = [];
    if (this.selectedServiceType == 1) {
      this.ogServiceList.forEach((element: any) => {
        if (element.shopStatus == 1) {
          element.toShow = true 
          this.serviceList.push(element);
        }
      });
      // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
    } else if (this.selectedServiceType == 0) {
      this.ogServiceList.forEach((element: any) => {
        if (element.homeStatus == 1){
          element.toShow = true 
          this.serviceList.push(element);
        } 
      });
      // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
    }
    // this.loader = true
    // this._apiService.getEntitySlotsInfo(this.entityHashId, this.bookingType, this.selectedValue)
    
  }
  selectedJobs:any = []
  selectServices(item:any){
    console.log(item);
    
    const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    console.log(index);
    
    this.selectedJobs.push(this.serviceList[index])
    if(this.selectedServiceType == 0){
      if(this.serviceList[index].discountStatus == 1){
        this.newbookingData.price += this.serviceList[index].homeDiscountedPrice
      }
      else if(this.serviceList[index].discountStatus == 0){
        this.newbookingData.price += this.serviceList[index].home_rate
      }
    }
    else if(this.selectedServiceType == 1){
      if(this.serviceList[index].discountStatus == 1){
        this.newbookingData.price += this.serviceList[index].shopDiscountedPrice
      }
      else if(this.serviceList[index].discountStatus == 0){
        this.newbookingData.price += this.serviceList[index].shop_rate
      }
    }
    this.serviceList[index].toShow = false
  }
  removeSelectedJobs(item:any){
    console.log(item);
    
    const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    const index1 = this.selectedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

    if(this.selectedServiceType == 0){
      if(this.selectedJobs[index1].discountStatus == 1){
        this.newbookingData.price -= this.newbookingData[index1].homeDiscountedPrice
      }
      else if(this.selectedJobs[index1].discountStatus == 0){
        this.newbookingData.price -= this.selectedJobs[index1].home_rate
      }
    }
    else if(this.selectedServiceType == 1){
      if(this.selectedJobs[index1].discountStatus == 1){
        this.newbookingData.price -= this.selectedJobs[index1].shopDiscountedPrice
      }
      else if(this.selectedJobs[index1].discountStatus == 0){
        this.newbookingData.price -= this.selectedJobs[index1].shop_rate
      }
    }

    this.serviceList[index].toShow = true
    this.selectedJobs.splice(index1,1)
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0'); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, '0'); // Same for minutes
    return `${hours}:${minutes}`;
}

addOneHourAndFormat(date: Date): string {
  const newDate = new Date(date);
  newDate.setHours(date.getHours() + 1);

  const hours = newDate.getHours().toString().padStart(2, '0');
  const minutes = newDate.getMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;
}

formatDateString(inputDateString: Date): string {
  const inputDate = new Date(inputDateString);
  const year = inputDate.getFullYear();
  const month = (inputDate.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
  const day = inputDate.getDate().toString().padStart(2, '0');
  const hours = inputDate.getHours().toString().padStart(2, '0');
  const minutes = inputDate.getMinutes().toString().padStart(2, '0');
  const seconds = inputDate.getSeconds().toString().padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

convertTo24HourFormat(time:any) {
  // Extract hours, minutes, and AM/PM from the time string
  const [timePart, amPm] = time.split(' ');
  const [hoursStr, minutesStr] = timePart.split(':');

  // Convert string components to numbers
  let hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  // Adjust hours based on AM/PM
  if (amPm.toLowerCase() === 'pm' && hours !== 12) {
      hours += 12;
  } else if (amPm.toLowerCase() === 'am' && hours === 12) {
      hours = 0;
  }

  // Construct a new Date object with a fixed date and the parsed time components
  const date = new Date(2000, 0, 1, hours, minutes);

  // Use Date methods to get hours, minutes, and seconds in 24-hour format
  const formattedHours = date.getHours().toString().padStart(2, "0");
  const formattedMinutes = date.getMinutes().toString().padStart(2, "0");

  const formattedTime = `${formattedHours}:${formattedMinutes}`;

  console.log(formattedTime);

  return formattedTime;
}

formatDate(dateStr:string) {
    
  // Split the date string by `/`
  const parts = dateStr.split('/');

  // Reverse the order of the parts and join them with `-`
  const newDateStr = parts.reverse().join('-');

  // Return the formatted date string
  return newDateStr;
}


ngOnDestroy(): void {
  this._apiSubscription.unsubscribe()
}
}
